module.exports = __webpack_public_path__ + "img/Truppführer_R.c046ee4a.svg";